import { useEffect } from 'react';
import { useOptionalVmClient } from '@/api/context';
import { useChatInputContext } from '@/contexts/ChatInputContext';

interface CommandQueueProcessorProps {
  handleSend: (message: string, filePaths?: string[]) => void;
  stop: () => void;
}

export const CommandQueueProcessor = ({ handleSend, stop }: CommandQueueProcessorProps) => {
  const { queue, consume } = useChatInputContext();
  const vmClient = useOptionalVmClient();

  useEffect(() => {
    if (queue.length === 0) return;
    if (!vmClient) return;
    const cmd = consume();
    if (!cmd) return;
    switch (cmd.type) {
      case 'send':
        handleSend(cmd.message, cmd.filePaths);
        cmd.ack();
        break;
      case 'stop':
        stop();
        cmd.ack();
        break;
    }
  }, [queue, consume, handleSend, stop, vmClient]);

  return null;
};
